import { useTheme } from "vuetify";

export function useDarkMode(): ComputedRef<boolean> {
  const theme = useTheme();
  return computed(() => theme.current.value.dark);
}
